import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "antd";
import { META_DATA } from "logic/src/constants";
import SocialMedia from "@/components/SocialMedia";
import cls from "classnames";
import useTrackCLK from "logic/src/utils/useTrackCLK";
import SJModal from "@/components/SJModal";
import SJButton from "@/components/SJButton";
import SJToast from "@/components/SJToast";
import { ResCode } from "logic/src/constants/request";
import { postUserFeedback } from "logic/src/services/richmodal";
import { REQUEST_ERR_TOAST } from "logic/src/constants/request";
import useMessage from "logic/src/utils/useMessage";

import styles from "./index.module.scss";

const { TextArea } = Input;
const MAX_COUNT = 1000;

const Feedback: React.FC<{
  open: boolean;
  onCancel: () => void;
}> = ({ open, onCancel }) => {
  const { sendCLK } = useTrackCLK();
  const { t } = useTranslation();
  const [userFeedback, setUserFeedback] = useState<string>("");
  const messageApi = useMessage();

  const handleSubmit = async () => {
    const feedbackText = userFeedback.trim();
    try {
      if (feedbackText) {
        sendCLK("feedback_click");
        const res = await postUserFeedback({
          user_feedback: feedbackText,
        });
        if (res.code === ResCode.Success) {
          handleClose();
          messageApi.success({
            content: t("sensechat-38"), // 感谢您的反馈意见
            className: "sj-success-message",
          });
        } else {
          throw Error(JSON.stringify(res));
        }
      }
    } catch (error) {
      console.log(error);
      SJToast.fail(REQUEST_ERR_TOAST);
    }
  };

  const handleClose = () => {
    setUserFeedback("");
    onCancel();
  };

  const handleGenCountTip = (info: {
    value: string;
    count: number;
    maxLength?: number;
  }) => {
    return (
      <div
        className={styles["text-count"]}
      >{`${info.count}/${info.maxLength}`}</div>
    );
  };

  return (
    <>
      <SJModal
        width={464}
        open={open}
        footer={null}
        closable={false}
        title={t("sensechat-241")}
        className={styles["feedback-modal"]}
      >
        <div className={styles["modal-feedback-content"]}>
          <TextArea
            value={userFeedback}
            maxLength={MAX_COUNT}
            placeholder={t("sensechat-37") as string} // "请输入您的宝贵建议"
            style={{ resize: "none" }}
            showCount={{ formatter: handleGenCountTip }}
            onChange={e => setUserFeedback(e?.target?.value || "")}
          />
          <div className={styles["footer-wrap"]}>
            <div>{META_DATA.area === "hk" && <SocialMedia />}</div>

            <div>
              <SJButton
                size="small"
                type="dashed"
                style={{ marginRight: 12 }}
                onClick={handleClose}
              >
                {t("sensechat-21")}
              </SJButton>
              <SJButton
                size="small"
                type="primary"
                disabled={!userFeedback.trim()}
                onClick={handleSubmit}
              >
                {t("sensechat-22")}
              </SJButton>
            </div>
          </div>
        </div>
      </SJModal>
      {messageApi.contextHolder}
    </>
  );
};
export default Feedback;
